import React from 'react';
import { useSelector } from 'react-redux';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { RootStore } from '../../store/reducers';
import './MUIProvider.d';
import {
  accentColorSelector,
  primaryColorSelector,
  primaryTextColorSelector,
  secondaryTextColorSelector,
} from '../../store/selectors/globalConfigSelectors';

interface IMUIProviderTemplate {
  children: React.ReactNode;
}

const MUIProviderTemplate: React.FC<IMUIProviderTemplate> = ({ children }) => {
  const { primaryColor, accentColor, primaryTextColor, secondaryTextColor } = useSelector(
    (state: RootStore) => ({
      primaryColor: primaryColorSelector(state),
      accentColor: accentColorSelector(state),
      primaryTextColor: primaryTextColorSelector(state),
      secondaryTextColor: secondaryTextColorSelector(state),
    }),
  );

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: primaryColor as string,
      },
      secondary: {
        main: accentColor as string,
      },
      text: {
        primary: primaryTextColor as string,
        secondary: secondaryTextColor as string,
      },
    },
    spacing: 8,
    custom: {
      inputs: {
        maxWidth: 480,
      },
      formText: {
        maxWidth: 583,
        marginBottomForSubSection: 20,
        marginBottomForSection: 32,
      },
      margin: {
        m20: 20,
        m8: 10,
      },
      fontSize: {
        primary: 16,
        subsection: 24,
        section: 32,
      },
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default MUIProviderTemplate;
